// extracted by mini-css-extract-plugin
export default {"pageWrap":"pd-z","fullWidth":"qd-z","heading":"rd-z","fullBleed":"sd-z","hidden":"td-z"};